import React from "react";
import { Figure } from "../Figure";
import { LineWithAverageData } from "../LineWithAverageData";
import { CategoryChart, prefixValue, suffixValue } from "../processors";
import { FigureSolidDashKpiProvider } from "../categoryChartQueryFns";
import { Paragraph } from "../Paragraph";
import { useCategoryContext } from "../Context";
import { CategoryTheme } from "../misc";

import styles from "./FigureWithSolidDashLine.module.scss";
import { getColor } from "../../themes";

interface FigureWithSolidDashLineProps extends FigureSolidDashKpiProvider {
    categoryChart: CategoryChart;
}

export const FigureWithSolidDashLine: React.FC<FigureWithSolidDashLineProps> = ({
    categoryChart,
    title,
    footer,
    figure,
    unit,
    graph
}) => {
    const { category } = useCategoryContext();

    if (!category) return null;

    const theme = category.theme as CategoryTheme;

    return (
        <div className="row">
            {title != null && <Paragraph title={""} status={true} nid={0} text={title} className="col-12" />}
            <div
                className={`col ${
                    figure != null && graph != null
                        ? "fix-width-col-400"
                        : figure != null && graph == null
                        ? "col-12"
                        : ""
                }`}
                style={{
                    display: figure != null ? undefined : "none"
                }}
            >
                {figure != null && (
                    <Figure
                        figureStyle={{
                            color: getColor(theme)
                        }}
                        className="w-100"
                        decimals={figure.decimals}
                        header={
                            !figure.header ? null : <Paragraph title={""} status={true} nid={0} text={figure.header} />
                        }
                        footer={
                            !figure.footer ? null : <Paragraph title={""} status={true} nid={0} text={figure.footer} />
                        }
                        value={figure.value}
                        prefix={prefixValue(figure.value, unit)}
                        suffix={suffixValue(figure.value, unit)}
                        unitInSuffix={unit}
                        unit={unit}
                        categoryChart={categoryChart}
                    />
                )}
            </div>

            {graph != null && (
                <div className={`col-12 ${styles.chart}`}>
                    <LineWithAverageData
                        measure={graph.measure}
                        theme={theme}
                        lineData={graph.lineData ?? []}
                        providerMedianSeriesName={graph.providerMedianSeriesName ?? ""}
                        providerMedianData={graph.providerMedianData ?? []}
                        providerMedianAnnotation={graph.providerMedianSeriesName ?? ""}
                        // largeProviderAverageSeriesName={graph.largeProviderAverageSeriesName ?? ""}
                        // largeProviderAverageData={graph.largeProviderAverageData ?? []}
                        years={graph.years ?? []}
                        unit={unit}
                        lineDataSeriesName={graph.lineDataSeriesName}
                        header={graph.header}
                        footer={graph.footer}
                    />
                </div>
            )}
            {footer != null && <Paragraph title={""} status={true} nid={0} text={footer} className="col-12" />}
        </div>
    );
};
